import 'reflect-metadata';
import { Expose, Type } from "class-transformer";
import { GeoJSONPoint } from 'ol/format/GeoJSON';
import { GeoJSONGeometry } from "ol/format/GeoJSON";

export class CountryDTO {
  @Expose({ name: 'country_acronym' })
  public country!: string;

  @Type(() => StateDTO)
  public states!: StateDTO[]
}

export function emptyCountryDTO() {
  const c = new CountryDTO();
  c.country = '';
  c.states = [];
  return c;
}

export class StateDTO {
  @Expose({ name: 'state_name' })
  public name?: string;
  @Expose({ name: 'state_acronym' })
  public acronym!: string;
}

export type City = string;

export class CityRequest {

  public static withCentroid(coordinates: number[]) {
    return new CityRequest({ type: 'Point', coordinates});
  }

  constructor(private readonly centroid: GeoJSONPoint) {}

}

export class CityDTO {
  @Expose({ name: "city_code" })
  public cityCode!: string;

  @Expose({ name: "city_name" })
  public cityName!: string

  @Expose({ name: "state_acronym" })
  public stateAcronym?: string;

  @Expose({ name: "state_name" })
  public stateName!: string;

  @Expose({ name: "country_acronym" })
  public countryAcronym!: string;

  @Expose({ name: "micro_region" })
  public microRegion!: string;
}

export class LocationDTO {
   public car!: string;
  public point!: GeoJSONPoint;

  @Type(() => GeomDTO)
  public geoms!: GeomDTO[]
}

export class GeomDTO {
  public geom!: GeoJSONGeometry;
}
